import { Button, Typography } from '@material-ui/core';
import React from 'react';
import Assinante from './Assinante';

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '50vh',
        minWidth: '50vw',
        justifyContent: 'space-around',
    },
};

const Items = ({
    value,
    title,
    getQuantidade = ({ quantidade }) => quantidade,
}) => {
    const items = value.reduce(
        (list, { nomeItem, listaPrecoItemNomeKit, ...rest }) => {
            const nome = listaPrecoItemNomeKit || nomeItem;
            let item = list.find((e) => e.nomeItem === nome);
            if (item) item.quantidade += getQuantidade(rest);
            else list.push({ nomeItem: nome, quantidade: getQuantidade(rest) });
            return list;
        },
        [],
    );

    const total = items.reduce(
        (total, { quantidade }) => total + quantidade,
        0,
    );

    return (
        <>
            <Typography variant="h5">{title}</Typography>
            {items.map(({ nomeItem, quantidade }) => (
                <div
                    key={nomeItem}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        borderBottom: '1px solid #e0e0e0',
                    }}
                >
                    <Typography style={{ flexGrow: 1 }}>{nomeItem}</Typography>
                    <Typography>{quantidade}</Typography>
                </div>
            ))}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Typography style={{ flexGrow: 1 }}>TOTAL</Typography>
                <Typography>{total}</Typography>
            </div>
        </>
    );
};

const ConfirmarRetirada = ({
    assinante,
    cartelas = [],
    selos = [],
    onConfirmar,
}) => {
    return (
        <div style={styles.root}>
            <Assinante value={assinante} />
            {cartelas.length && <Items title="Cartelas" value={cartelas} />}
            {selos.length > 0 && (
                <Items
                    title="Selos"
                    value={selos}
                    getQuantidade={(e) =>
                        e.quantidade *
                        e.listaPrecoItemDerivacaoProdutoQuantidade
                    }
                />
            )}

            <div style={{ marginTop: '20px' }}>
                <Button onClick={onConfirmar}>Confirmar</Button>
            </div>
        </div>
    );
};

ConfirmarRetirada.defaultProps = {
    assinante: {},
    cartelas: [],
    onConfirmar: console.warn,
};

export default ConfirmarRetirada;
